import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'saHelpVideoPipe'
})
export class SaHelpVideoPipePipe implements PipeTransform {

  transform(helpVideoData: any[], searchTermVideo: string): any[] {
    if (!helpVideoData || !searchTermVideo) { return helpVideoData; }
    return helpVideoData.filter(data =>
      data.title.toLowerCase().indexOf(searchTermVideo.toLowerCase()) !== -1
   

    );
  }

}
